import React, { useEffect, useMemo, useState } from 'react';
import InventoryTablePage from '../components/inventory/InventoryTablePage';
import { productsApi, storesApi } from '../services/api';

export default function LowStocksPage() {
    const [rows, setRows] = useState([]);

    const loadRows = () => {
        Promise.all([productsApi.lowStock(), storesApi.list({ limit: 200 })]).then(([lowStockRes, storesRes]) => {
            const products = lowStockRes?.data || [];
            const stores = storesRes?.data?.data || [];
            const storesById = Object.fromEntries(stores.map((store) => [String(store.id), store]));
            const mapped = products.map((item) => ({
                id: item.id,
                store: storesById[String(item.store_id)]?.name || 'Unassigned',
                productName: item.name,
                category: item.category,
                sku: item.sku,
                qty: item.quantity_in_stock,
                qtyAlert: item.reorder_level,
                icon: (item.name || '?').slice(0, 1).toUpperCase(),
            }));
            setRows(mapped);
        });
    };

    useEffect(() => {
        loadRows();
    }, []);

    const columns = useMemo(() => [
        { key: 'store', label: 'Store' },
        {
            key: 'productName',
            label: 'Product Name',
            render: (row) => (
                <div className="product-name-cell compact">
                    <div className="product-thumb">{row.icon}</div>
                    <strong>{row.productName}</strong>
                </div>
            ),
        },
        { key: 'category', label: 'Category' },
        { key: 'sku', label: 'SKU' },
        { key: 'qty', label: 'Qty' },
        { key: 'qtyAlert', label: 'Qty Alert' },
    ], []);

    const exportCsv = () => {
        const header = ['Store', 'Product Name', 'Category', 'SKU', 'Qty', 'Qty Alert'];
        const lines = rows.map((item) => [item.store, item.productName, item.category, item.sku, item.qty, item.qtyAlert]);
        const csv = [header, ...lines].map((line) => line.map((value) => `"${String(value || '').replace(/"/g, '""')}"`).join(',')).join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'low-stock-products.csv';
        link.click();
        URL.revokeObjectURL(url);
    };

    return <InventoryTablePage title="Low Stocks" breadcrumb="Low Stocks" rows={rows} columns={columns} filterOptions={<></>} toolbarButtons={<><button className="mini-icon-btn" type="button" onClick={loadRows}>↻</button><button className="btn" type="button" onClick={exportCsv}>Export Low Stock</button></>} />;
}
